
import { Box, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import YouTube from 'react-youtube';

export default function ProductRedeemVideo({ videoId = "https://youtu.be/zI3xnG4dGDI?si=XdjfSsZ-eAd4Z0OQ" }) {
    const [ytcode, setYTCode] = useState('')

    useEffect(() => {
        const ytCode = extractYouTubeVideoID(videoId);
        setYTCode(ytCode)
    }, [videoId])

    const opts = {
        height: '390px',
        width: '100%',
        playerVars: {
            autoplay: 1,
            controls: 1,
            modestbranding: 1,
            rel: 0,
            showinfo: 1,
        },
    };

    const onReady = (event) => {
        event.target.pauseVideo();
    };

    return (
        <Grid container sx={{
            justifyContent: "center"
        }}>
            <Grid item sm={8} lg={8} >
                <Box sx={{
                    p: 1,
                    pb: "4px",
                    boxShadow: 3,
                    borderRadius: 2,
                    backgroundColor: "#d2e4ff",
                    minHeight: 380
                }}>

                    <YouTube
                        videoId={ytcode}
                        opts={opts}
                        onReady={onReady}
                        className="youtube-player"
                    />

                </Box>
            </Grid>
        </Grid>
    )
}


function extractYouTubeVideoID(url) {
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
}  